export enum ResponseStatus {
  SUCCESS = 'Success',
  ERROR = 'Error',
  NOT_FOUND = 'NotFound',
  UN_AUTHORIZE = 'UnAuthorize',
  VALIDATION_ERROR = 'ValidationError',
}
